<script setup lang="ts">
import BattingParticipant from './BattingParticipant.vue'
import ChangeToHalfButton from './ChangeToHalfButton.vue'
import PocketIncidents from './PocketIncidents.vue'
</script>

<template>
  <div class="flex gap-x-2">
    <ChangeToHalfButton />
    <BattingParticipant />
    <PocketIncidents />
  </div>
</template>
